import MainLayout from 'layouts/MainLayout';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend, ArcElement } from 'chart.js';
import {
  EmploymentChart,
  IncubatedCompanyChart,
  InvestmentChart,
  PatentChart,
  ProjectChart,
  SalesChart,
  VentureChart,
} from 'components/chart';
import useDashboard from 'hooks/useDashboard';

ChartJS.register(BarElement, CategoryScale, LinearScale, ArcElement, Title, Tooltip, Legend);

const AdminDashboard = () => {
  const { useGetDashboard } = useDashboard();
  const { dashboardInfo } = useGetDashboard({});

  if (!dashboardInfo) return;

  return (
    <MainLayout>
      <div className="chart-card">
        <div className="page-card">
          <ProjectChart statsData={dashboardInfo.projectStats} />
        </div>
        <div className="page-card">
          <IncubatedCompanyChart statsData={dashboardInfo.incubatedCompanyStats} />
        </div>
      </div>
      <br />
      <div className="chart-card">
        <div className="page-card">
          <SalesChart statsData={dashboardInfo.salesStats} />
        </div>
        <div className="page-card">
          <EmploymentChart statsData={dashboardInfo.employmentStats} />
        </div>
        <div className="page-card">
          <InvestmentChart statsData={dashboardInfo.investmentStats} />
        </div>
      </div>
      <br />
      <div className="chart-card">
        <div className="page-card">
          <PatentChart statsData={dashboardInfo.patentStats} />
        </div>
        <div className="page-card">
          <VentureChart statsData={dashboardInfo.ventureStats} />
        </div>
      </div>
    </MainLayout>
  );
};

export default AdminDashboard;
